











import { Component, Vue } from "vue-property-decorator";
import { deleteInstanceGroup } from "@/services/instances/instanceGroupService";

    @Component
export default class InstanceGroupDeleteModal extends Vue {
        // local state
        groupToDeleteId: string = "";

        // lifecycle hooks

        // computed

        // methods
        open(instanceGroupId: string) {
            this.groupToDeleteId = instanceGroupId;
            this.$bvModal.show("modal-deleteInstanceGroup");
        }

        declineDelete() {
            this.groupToDeleteId = "";
            this.$bvModal.hide("modal-deleteInstanceGroup");
        }

        confirmDelete() {
            this.$bvModal.hide("modal-deleteInstanceGroup");
            deleteInstanceGroup(this.groupToDeleteId).then(() => {
                this.$emit("reload");
            });
        }
}
